import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Root from "./routes/root";
import Settings from "./components/settings/Settings";
import ErrorPage from "./components/errorpage/ErrorPage";
import Workspaces from "./components/workspaces/Workspaces";
import Signup from "./components/signup/Signup";
import Login from "./components/login/Login";
import Logout from "./components/logout/Logout";
import { FormEditor } from "./components/form-editor/FormEditor";
import { FormResponses } from "./components/form-responses/FormResponses";
import { FormShare } from "./components/form-share/FormShare";
import { FormCollect } from "./components/form-collect/FormCollect";
import { FormSettings } from "./components/form-settings/FormSettings";
import Tags from "./components/tags/Tags";
import Templates from "./components/templates/Templates";
import { HelpCenter } from "./components/help-center/HelpCenter";
import { Support } from "./components/support/Support";
import { Auth0Provider } from "@auth0/auth0-react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import config from "environment";
import { Provider } from "react-redux";
import store from "./redux/store";
import { saveState } from "./utils/localStorage";
import throttle from "lodash/throttle";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Helmet } from "react-helmet";
import Home from "./components/home/Home";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Navigate to="/home" />,
      },
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/home/:tagId",
        element: <Home />,
      },
      {
        path: "/tags",
        element: <Tags />,
      },
      {
        path: "/templates",
        element: <Templates />,
      },
      {
        path: "/workspaces",
        element: <Workspaces />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/help",
        element: <HelpCenter />
      },
      {
        path: "/support",
        element: <Support />
      }
    ],
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/logout",
    element: <Logout />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/editor",
    element: <FormEditor />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/form-settings",
    element: <FormSettings />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/responses/:formPublicLink",
    element: <FormResponses />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/share/:formId",
    element: <FormShare />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/preview/:formId",
    element: <FormCollect isPreview={true} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/form/:publicLink",
    element: <FormCollect isPreview={false} />,
    errorElement: <ErrorPage />,
  }

]);

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

sessionStorage.setItem("signup", "false");

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }),
  1000
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOAUTH_CLIENT_ID}>
      <Auth0Provider
        // domain="dev-nw12vlxbhf5opc5z.us.auth0.com"
        domain="login.usewinslow.com"
        clientId="Dhv04GgqrrH9tt0iEZ6UF1SnzxNeuRnD"
        authorizationParams={{
          redirect_uri: config.redirect,
          audience: "https://dev-nw12vlxbhf5opc5z.us.auth0.com/api/v2/",
          prompt: "select_account",
        }}
        skipRedirectCallback={window.location.pathname === "/settings"}>
        <Provider store={store}>
          <Helmet>
            <title>effno</title>
            <meta property="og:title" content="effno" />
            <meta name="og:description" content="Stop paying for overpriced software." />
            <meta name="description" content="Stop paying for overpriced software." />
            {/* <meta name="slack-app-id" content="A0623PANF34" /> */}
          </Helmet>
          <DndProvider backend={HTML5Backend}>
            <RouterProvider router={router} />
          </DndProvider>
        </Provider>
      </Auth0Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
